<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import EmployeeAPI from "@/services/employee/employeeAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import { required } from "vuelidate/lib/validators";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import restriccionesColaboracionesAgregarAPI from "../../../services/standards/restriccionesColaboraciones/restriccionesColaboracionesAgregarAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Restricciones y recomendaciones laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "3.6.1-1 Restricciones y recomendaciones laborales",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Restricciones y recomendaciones laborales",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/restricciones-colaboraciones-agregar`,
        },

        {
          text: "Editar",
          active: true,
        },
      ],

      submitted: false,
      lista: [],

      usersList: [],
      loading1: true,
      loading2: true,
      file: null,
      itemData: null,
      acta: null,

      company: this.$store.getters["company/getCompany"],

      addRecomendacion: {
        date: null,
        entity: null,
        restriction: null,
        employee_id: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    addRecomendacion: {
      date: {
        required,
      },
      entity: {
        required,
      },
      restriction: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(23)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },


    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.addRecomendacion.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.6/recomendaciones/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.6/recomendaciones/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.addRecomendacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getRestriccion() {
      restriccionesColaboracionesAgregarAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.addRecomendacion = {
            date: response.data.date,
            entity: response.data.entity,
            restriction: response.data.restriction,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
            file: response.data.file,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    async update() {
      try {
        this.submitted = true
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          restriccionesColaboracionesAgregarAPI
            .update(this.$route.params.id, {
              date: this.addRecomendacion.date,
              entity: this.addRecomendacion.entity,
              restriction: this.addRecomendacion.restriction,
              employee_id: this.addRecomendacion.employee_id,
              companies_id: this.addRecomendacion.companies_id,
              file: this.addRecomendacion.file
            })
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 28,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false;
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Informacion actualizada con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }, 1500);
                  this.$router.go(-1);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((err) => {
              console.log(" error: ", err);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.loading2 = false;
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
          this.loading2 = false;
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getRestriccion();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Nombre del colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="addRecomendacion.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha" label-for="date_exam">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="date" id="date_exam"
                      v-model="addRecomendacion.date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group id="cycle" label-for="cycle" class="col-md-6 px-2" label="Entidad">
                    <select required :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="addRecomendacion.entity">
                      <b-form-select-option value="ARL">
                        ARL
                      </b-form-select-option>
                      <b-form-select-option value="EPS">
                        EPS
                      </b-form-select-option>
                      <b-form-select-option value="Otro">
                        Otro
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Restricción y/o recomendación" label-for="file">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" required type="text"
                      v-model="addRecomendacion.restriction" maxlength="30">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="addRecomendacion.file ? getFile(addRecomendacion.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>